import { uniqueId } from 'lodash';
import validator from 'validator';
import { PhoneBookActionsType, PhoneBookType } from '../types';

export const phoneBookAction = {
  isOpenEntry: false,
  isOpenEntryConfirmation: false,
  isOpenAddEditCancelConfirmation: false,
  isOpenNotifications: false,
  isOpenDeleteEntryConfirmation: false,
  title: 'Email',
  haveSelections: false
} as PhoneBookActionsType;

export const phoneBookNew = (sourceType = '') =>
  JSON.parse(
    JSON.stringify({
      sourceType,
      id: 0,
      sourceId: 0,
      sourceName: '',
      name: '',
      contactGroupList: [],
      terminalList: [],
      phone1: 0,
      phone1CountryCodeMappingId: 0,
      phone2: 0,
      phone2CountryCodeMappingId: 0,
      email1: '',
      email2: '',
      isCategory: false,
      categoryName: '',
      emailNotification: null,
      smsNotification: null,
      markForDeletion: false,
      mx_internal_uid: uniqueId()
    } as PhoneBookType)
  ) as PhoneBookType;

export const clearNumberMask = (number: any) => {
  return number.toString().replace(/[-]+/, '').replace(/[\s]+/, '').replace(/[(]+/, '').replace(/[)]+/, '');
};

export const notEmptyEmail = (value = '') => {
  return value && !validator.isEmail(value) && `${value} is not a valid email.`;
};

export const setPhoneNumberMask = (value: any): string => {
  const result = value?.toString();
  if (result?.length === 10) {
    return `(${result.substring(0, 3)}) ${result.substring(3, 6)}-${result.substring(6, 10)}`;
  }
  return ``;
};

export const getPhones = (element: any): string => {
  return element.phone1 || element.phone2
    ? element.phone1 && element.phone2
      ? `${setPhoneNumberMask(element.phone1)} , ${setPhoneNumberMask(element.phone2)}`
      : `${setPhoneNumberMask(element.phone1)}` || `${setPhoneNumberMask(element.phone2)}`
    : '';
};

export const getEmails = (element: any): string => {
  return element.email1 || element.email2
    ? element.email1 && element.email2
      ? `${element.email1} ,${element.email2}`
      : element.email1 || element.email2
    : '';
};
